import { type metrics } from "@north-beam/nb-common";

type LeftParenthesis = "(";
type RightParenthesis = ")";
export type OperatorInput =
  | metrics.Operator
  | LeftParenthesis
  | RightParenthesis;

export const OPERATOR_ICONS: Record<OperatorInput, string> = {
  "+": "plus",
  "-": "minus",
  "*": "multiply",
  "/": "divide",
  "(": "bracket-round",
  ")": "bracket-round-right",
} as const;

export const OPERATOR_ICON_LIST = Object.entries(OPERATOR_ICONS).map(
  ([value, icon]) => ({
    icon,
    value,
  }),
);
